(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-webinar-article"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initWebinarVideos = (root = document) => {
      root.querySelectorAll('[data-webinar-video]').forEach((container) => {
        if (container.dataset.webinarVideoInitialized === 'true') return;

        const video = container.querySelector('video');
        const playButton = container.querySelector('[data-webinar-video-play]');

        if (!video || !playButton) return;

        const syncPlayButton = () => {
          const isPlaying = !video.paused && !video.ended;
          container.classList.toggle('is-playing', isPlaying);
          playButton.setAttribute('aria-hidden', isPlaying ? 'true' : 'false');
          playButton.tabIndex = isPlaying ? -1 : 0;
        };

        playButton.addEventListener('click', () => {
          if (video.paused || video.ended) {
            video.play();
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', syncPlayButton);
        video.addEventListener('pause', syncPlayButton);
        video.addEventListener('ended', syncPlayButton);

        container.dataset.webinarVideoInitialized = 'true';
        syncPlayButton();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initWebinarVideos());
    } else {
      initWebinarVideos();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initWebinarVideos(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-newsletter-signup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function buildUrl(root, name, email) {
      var actionUrl = (root.dataset.activeCampaignActionUrl || '').trim();
      var userId = (root.dataset.activeCampaignUserId || '').trim();
      var formId = (root.dataset.activeCampaignFormId || '').trim();
      if (!actionUrl || !userId || !formId) return '';

      var params = new URLSearchParams({
        u: userId,
        f: formId,
        s: '',
        c: '0',
        m: '0',
        act: 'sub',
        v: '2',
        name: name,
        email: email,
        jsonp: 'true'
      });

      return actionUrl + (actionUrl.indexOf('?') === -1 ? '?' : '&') + params.toString();
    }

    function submitToActiveCampaign(root, name, email) {
      var url = buildUrl(root, name, email);
      if (!url || typeof window.fetch !== 'function') return Promise.resolve(false);

      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = window.setTimeout(function () {
        if (controller) controller.abort();
      }, 10000);

      return window
        .fetch(url, {
          method: 'GET',
          mode: 'cors',
          cache: 'no-store',
          credentials: 'omit',
          signal: controller ? controller.signal : undefined
        })
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (body) {
          if (body.indexOf('_show_error(') !== -1) return false;
          if (body.indexOf('_show_thank_you(') !== -1) return true;

          var redirect = body.trim().match(/^window\.top\.location\.href\s*=\s*"([^"]+)"\s*;?$/);
          if (!redirect) return false;

          try {
            var destination = new URL(redirect[1]);
            return (destination.origin === window.location.origin && destination.pathname === '/pages/pro') ||
              (destination.origin === 'https://reneerouleau.activehosted.com' && destination.pathname === '/f/confirm.php');
          } catch (error) {
            return false;
          }
        })
        .catch(function () {
          return false;
        })
        .finally(function () {
          window.clearTimeout(timer);
        });
    }

    function init(root) {
      if (root.dataset.proSignupReady === 'true') return;
      root.dataset.proSignupReady = 'true';

      var form = root.querySelector('[data-pro-signup-form]');
      var success = root.querySelector('[data-pro-signup-success]');
      var error = root.querySelector('[data-pro-signup-error]');
      if (!form) return;

      var nameInput = form.querySelector('input[name="name"]');
      var emailInput = form.querySelector('input[name="email"]');
      var submitButton = form.querySelector('button[type="submit"]');

      function hideError() {
        if (error) error.hidden = true;
        nameInput.removeAttribute('aria-invalid');
        emailInput.removeAttribute('aria-invalid');
      }

      function showError(kind, field) {
        if (error) {
          var message = error.getAttribute(kind === 'submit' ? 'data-submit-message' : 'data-validation-message');
          if (message) error.textContent = message;
          error.hidden = false;
        }
        if (field) {
          field.setAttribute('aria-invalid', 'true');
          field.focus();
        }
      }

      nameInput.addEventListener('input', hideError);
      emailInput.addEventListener('input', hideError);

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        hideError();

        var name = nameInput.value.trim();
        var email = emailInput.value.trim();

        if (!name) {
          showError('validation', nameInput);
          return;
        }

        if (!email || !emailInput.checkValidity()) {
          showError('validation', emailInput);
          return;
        }

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
        }

        submitToActiveCampaign(root, name, email).then(function (accepted) {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.setAttribute('aria-busy', 'false');
          }

          if (!accepted) {
            showError('submit');
            return;
          }

          form.hidden = true;
          if (success) {
            success.hidden = false;
            var heading = success.querySelector('[data-pro-signup-success-heading]');
            if (heading) heading.focus();
          }
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-pro-signup]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
